<template>
  <div class="hello">
    <div class="registerMask" v-if="showModel">
      <div class="register">
        <div class="clo" @click="closeEvent">
          <img src="../assets/image/close.png" alt="">
        </div>
        <div class="logonav">
          <div class="logo">
             <img src="../assets/image/searchlogo.png" alt="" >
          </div>
        </div>
        <div class="fromList">

          <div class="fromTop">
            <span>{{$t('language.Registered')}}</span>
          </div>
          <div class="line"></div>
          <div class="phoneLable">
            <input class="myInput" v-model="form.phone" type="text" :placeholder="$t('language.phone')" v-on:keyup="check_count($event)">
            <!-- <input type="text" name="" value="" v-on:keyup="check_count($event)"> -->
          </div>
          <div class="verification">
            <div class="code">
              <input type="text" v-model="form.code" class="myInput">
            </div>
            <div class="codeBtn" :class="{prohibit:isprohibit}" @click="getCode">
              <span>{{lastTimeContent }}</span>
            </div>
          </div>
          <div class="passworld">
            <input type="password" v-model="form.password" class="myInput" :placeholder="$t('language.numbers')">
          </div>
     <!--     <div class="agreement">
            <el-checkbox v-model="checked" @change="checkedChange"></el-checkbox>
            <span>{{$t('language.read')}}<a class="ins" @click="userInfo">{{$t('language.User')}}</a>{{$t('language.and')}}<a
                class="ins" @click="getPrivacyPolicy">{{$t('language.Privacy')}}</a></span>
          </div> -->
          <div class="loginBtn" :class="{loginActive:checked}" @click="loginEvent">
            <span>{{$t('language.login')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="infoShow">
      <div class="info">
        <div class="content" v-html="info">

        </div>
        <div class="sub" @click="closeE">
          <span>确定</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    props: {
      showModel: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        infoShow: false,
        info: '',
        isprohibit: false,
        time: '',
        lastTimeContent: '',
        checked: false,
        form: {
          phone: '', // 手机号
          code: '', //验证码
          password: '' // password 密码
        }
      }
    },
    computed: {
      // lastTimeContent(){
      //   return this.$t('language.code')
      // },
    },
    created() {
      this.lastTimeContent = this.$t('language.code')
      if (localStorage.getItem('lastTime')) {
        let lastTime = localStorage.getItem('lastTime');
        let timer = setInterval(() => {
          if (lastTime > 0) {
            this.lastTimeContent = lastTime + 's' + this.$t('language.Resend');
            this.isprohibit = true;
            lastTime--;
            localStorage.setItem('lastTime', lastTime);
          } else {
            this.isprohibit = false;
            window.clearInterval(timer);
            this.lastTimeContent = this.$t('language.code')
          }
        }, 1000);
      }
    },
    methods: {
      closeE() {
        this.infoShow = false;
      },
      // 用户协议
      userInfo() {
        this.$fetch('/Content/getUserAgreement').then(res => {
          this.info = res.data.info;
          this.infoShow = true;
        })
      },
      //隐私政权
      getPrivacyPolicy() {
        this.$fetch('/Content/getPrivacyPolicy').then(res => {
          this.info = res.data.info;
          this.infoShow = true;
        })
      },
      getCode() {
        if (localStorage.getItem('lastTime') && localStorage.getItem('lastTime') > 0) {
          return
        } else {
          if (this.form.phone) {
            console.log(this.lastTimeContent);
            console.log(this.$t('language.code'))
            if (this.lastTimeContent == '发送验证码' || this.lastTimeContent == 'Send verification code') {

              console.log(this.form.phone);

              this.$post('/Sms/sendCode', {
                phone: this.form.phone
              }).then(res => {
                if (res.code == 200) {
                  this.$message.success('发送成功')
                  let lastTime = 59;
                  let timer = setInterval(() => {
                    if (lastTime > 0) {
                      this.lastTimeContent = lastTime + 's' + this.$t('language.Resend');
                      this.isprohibit = true;
                      lastTime--;
                      localStorage.setItem('lastTime', lastTime);
                    } else {
                      this.isprohibit = false;
                      window.clearInterval(timer);
                      this.lastTimeContent = this.$t('language.code')
                    }
                  }, 1000);
                }
              })
            }
          } else {
            this.$message({
              showClose: true,
              message: this.$t('language.phone'),
              type: 'error'
            });
          }
        }

      },
      checkedChange() {
        console.log(this.checked)
      },

      loginEvent() {
        var that = this;
        if(this.form.phone == ''){
          that.$message.error('请填写手机号');
          return
        }
        if(this.form.code == ''){
          that.$message.error('请填写验证码');
          return
        }
        if(this.form.password == ''){
          that.$message.error('请填写密码');
          return;
        }
        console.log(this.form);
       this.$post('/User/register', this.form).then(res => {
         if (res.code == 200) {
           var data = {
             loginType: '2',
             phone: this.form.phone,
             password: this.form.password
           }
           // 注册完成 立即登录
           that.$post('/User/login', data).then(res => {
             if (res.code == 200) {
               that.$message.success('登录成功');
               localStorage.setItem('access_token', res.data.access_token);
               localStorage.setItem('refresh_token', res.data.refresh_token);
               localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
               this.$emit('childByValue', false)
               this.$emit('userInfo', res.data.userInfo);
               that.showModel = false;
               location.reload();
             }
           })

         }
       })
      },
      closeEvent() {
        this.showModel = false;
        this.$emit('registerV', this.showModel)
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/register.css");
</style>



// WEBPACK FOOTER //
// src/components/register.vue